export enum EKnowledgeBaseSection {
    Native = "native",
    Connected = "connected",
}

export enum EKnowledgeBaseCardSection {
    Documents = "documents",
    NoticeBoard = "notice-board",
    Library = "library",
}

export enum EKnowledgeBaseItemType {
    File = "file",
    Web = "web",
}
